import {AiOutlineDeploymentUnit} from 'react-icons/ai';
import {BiWorld} from 'react-icons/bi';
import {FaDatabase} from 'react-icons/fa';
import {GiProcessor} from 'react-icons/gi';
import {LuCircuitBoard} from 'react-icons/lu';
import {MdModelTraining, MdOutlineArrowOutward} from 'react-icons/md';
import {PiShippingContainerDuotone} from 'react-icons/pi';
import {RiLayout4Line} from 'react-icons/ri';
import CardSubsection from './CardSubsection';
import CardWithBackground from './CardWithBackground';
import SvgIcon from './SvgIcon';

export const components = {
  SvgIcon,
  CardWithBackground,
  BiWorld,
  MdOutlineArrowOutward,
  LuCircuitBoard,
  CardSubsection,
  RiLayout4Line,
  MdModelTraining,
  AiOutlineDeploymentUnit,
  PiShippingContainerDuotone,
  FaDatabase,
  GiProcessor
};
